import { NewSchedulerHelper } from '../../../../../../../utils/maintenanceWindow/patchManagement/NewSchedulerHelper';
import { NewScheduler } from '../../../../../../../types/common/maintenanceWindowPatchManagementTypes';
import { RecurrenceOptions } from '../../../../../../../types/common/schedulerTypes';

export class NewSchedulerHelperV2 extends NewSchedulerHelper {
  getShortDescription(data: NewScheduler): string {
    // immediately recurrence is shown for Patch Management V2
    if (data.recurrence === RecurrenceOptions.IMMEDIATELY) {
      return this.dependencies.translateFn('Immediately after scan');
    }

    return super.getShortDescription(data);
  }
}
